<div class="burger-line" [class.burgerTop]="open"></div>
<div class="burger-line" [class.burgerMiddle]="open"></div>
<div class="burger-line" [class.burgerBottom]="open"></div>
